import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    wrapFilter: {
        display: 'flex', marginRight: 12
    },
    wrapSwitch: {
        display: 'flex', alignItems: 'center', marginRight: 20
    },
    manuallyHelper: {
        color: '#fff', marginRight: 8
    },
    spo: {
        width: 40, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        background: '#141b33',
        borderRadius: '4px',
        color: '#fff',
        boxShadow: '4px 4px 8px 0px rgb(34 60 80 / 20%)',
    },
    inp: {
        border: 'none', 
        outline: 'none', 
        paddingLeft: 15, 
        borderRadius: 4, 
        background: '#34488c',
        color: '#fff'
    },
    wrapPanel: {
        width: '100%', display: 'flex', justifyContent: 'space-between', columnGap: 10
    },
    block: {
        height: 40, marginTop: 12, display: 'flex', alignItems: 'center', justifyContent: 'space-between', border: '1px solid #b0b0b0', borderRadius: 4, width: '25%', padding: 20
    },
    blockText: {
        color: '#fff', fontSize: 26, fontWeight: 700
    }
}));

export {
    useStyles,
}